/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExcisetaxMiscBill.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excisetax-misc-bill";

export class AutogenModelExcisetaxMiscBill<RowType extends ModelRow> extends Endpoint<RowType, RowExcisetaxMiscBillFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExcisetaxMiscBill extends ModelRow<RowExcisetaxMiscBillFields> {
	constructor(values?: Partial<RowExcisetaxMiscBillFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExcisetaxMiscBillFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_type: string;
	company_id: string;
	descr: string;
	excisetax_id: string;
	id: string;
	method: string;
	misc_bill_id: string;
	rate: number;
	state_id: string;
	units: number;
}

